import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "key-border" }, null, -1 /* HOISTED */)

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Keycap',
  props: {
  width: { type: String, default: "60px" },
  height: { type: String, default: "60px" },
  top: { type: String, default: "0px" },
  left: { type: String, default: "0px" },
  fontSize: { type: String, default: "28px" },
},
  setup(__props) {

const props = __props;



const style = computed(() => {
  return {
    top: props.top,
    left: props.left,
    width: props.width,
    height: props.height,
  };
});

const capStyle = computed(() => {
  return {
    fontSize: props.fontSize,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "key",
    style: _normalizeStyle(style.value)
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "cap",
      style: _normalizeStyle(capStyle.value)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4 /* STYLE */)
  ], 4 /* STYLE */))
}
}

})